import { useDesktopDeepLinks } from '@/desktop/useDesktopDeepLinks';
import { DesktopUpdateBanner } from '@/components/desktop/DesktopUpdateBanner';
import { isElectron } from '@/utils/platform';

/** Desktop-only hooks and banners wired at the router root. */
export function DesktopShellExtras() {
  useDesktopDeepLinks();
  if (!isElectron()) return null;
  return <DesktopUpdateBanner />;
}
